import { initApollo } from "utils/apollo";
export const client = initApollo();
